import { Component } from '@angular/core';
import { FavoritesFacade } from '@ridango/components/lib/favorites/+state/favorites.facade';
import { NetworkService } from '@ridango/core';

@Component({
    selector: 'rwidget-explore-favorite-schedule',
    templateUrl: './explore-favorite-schedule.component.html',
    styleUrls: ['./explore-favorite-schedule.component.scss']
})
export class ExploreFavoriteScheduleComponent {
    favoriteSchedules$ = this.FavoritesFacade.favoriteSchedules$;
    deviceStatus = this.network.getCurrentStatus();

    constructor(
        private FavoritesFacade: FavoritesFacade,
        private network: NetworkService
    ) {}
}
